import {useEffect} from 'react'

const useOnWindowResize = (fn: Function, delay: number = 50) => {
    useEffect(() => {
        let timeoutId: number | undefined

        const resizeListener = () => {
            window.clearTimeout(timeoutId)
            timeoutId = window.setTimeout(fn, delay)
        }

        window.addEventListener('resize', resizeListener)

        return () => {
            window.removeEventListener('resize', resizeListener)
        }
    }, [fn, delay])
}

export default useOnWindowResize
